export default __webpack_public_path__ + "static/Graphik-Bold-Web-1ad40a28c937aa329f8b2456cf36dbac.woff2";